import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import {ReactComponent as PlusSVG} from "../../../images/icons/plus.svg";
import CartPromotionsComponent from "./CartPromotionsComponent";
import DrawerVouchers from "../Navbar/DrawerVouchers/DrawerVouchers";

interface OwnProps {
    updateErrors: (errors: any) => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const CartPromotionsSection = (props: Props) => {
    const {t} = useTranslation();
    const [showPromotionsDrawer, setShowPromotionsDrawer] = useState(false);

    return (
        <div className={"card-cart cart-promotions-section"}>
            <div className={"container-fluid"}>
                <h5 className={"card-cart-header"}>
                    {t("modules.cart.field.discounts_and_vouchers.title")}
                </h5>
                <div className={"card-cart-body"}>
                    {showPromotionsDrawer && (
                        <DrawerVouchers show={showPromotionsDrawer} onHide={() => setShowPromotionsDrawer(false)}/>
                    )}
                    <CartPromotionsComponent updateErrors={props.updateErrors}/>
                    <div className="row">
                        <div className="col-md-6">
                            <button className={"btn btn-outline-primary btn-lg w-100"}
                                    onClick={() => setShowPromotionsDrawer(true)}>
                                <PlusSVG/> {t("modules.cart.action.discount_or_activate_voucher.title")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartPromotionsSection));